// pages/login.js
'use client'

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';
import styles from 'styles/scss/components/_LoginComponent.module.scss';

const LoginComponent = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const router = useRouter();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Credenciales estáticas
    const credenciales = {
      'admin':'1Ndr@3mple0',
      'editor-indra':'#yFrE12USUyoe@%VqAK(djeV'
    }


    if (credenciales[username] && password === credenciales[username] ) {
      // Establecer una cookie de autenticación con expiración de 24 horas
      //const token = generateToken({userId: username});
      Cookies.set('authenticated', 'true', {expires:1});
      //Cookies.set('token', token, {expires:1});

      router.push('/');
    } else {
      alert('Credenciales incorrectas');
    }
  };

  return (
      <div className={styles.loginContainer}>
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Nombre de usuario"
          />
          <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contraseña"
          />
          <button type="submit">Iniciar sesión</button>
        </form>
      </div>
  );
};

export default LoginComponent;